import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import { Dot } from "../components/site/Section";

export default function NotFound() {
  return (
    <div className="App">
      <Navbar />
      <main className="wrap notfound">
        <div>
          <span className="label">404</span>
          <h1 style={{ marginTop: 14 }}>Last orders<Dot /></h1>
          <p className="lede" style={{ margin: "16px auto 28px" }}>That page has called it a night. Let's get you back to the bar.</p>
          <Link to="/" className="btn btn-green" data-testid="notfound-home">Back to home</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
